/** Canonical role slugs (must match backend JWT /users/me). */
export const R = {
  ADMIN: "admin",
  HR: "hr",
  MANAGER: "manager",
  FINANCE: "finance",
  EMPLOYEE: "employee",
};

export const ANY_AUTHENTICATED = [R.ADMIN, R.HR, R.MANAGER, R.EMPLOYEE, R.FINANCE];
export const STAFF = [R.ADMIN, R.HR];
export const PAYROLL_STAFF = [R.ADMIN, R.HR, R.FINANCE];
export const TEAM_LEADS = [R.ADMIN, R.HR, R.MANAGER];
export const SELF_SERVICE = [R.EMPLOYEE, R.MANAGER, R.HR];
export const ADMIN_ONLY = [R.ADMIN];

export function normalizeRole(role) {
  if (role == null || typeof role !== "string") return null;
  const s = role.trim().toLowerCase();
  if (!s) return null;
  if (s === "superuser" || s === "super_admin" || s === "superadmin") return R.ADMIN;
  return s;
}

export function isAdminLike(role) {
  const r = normalizeRole(role);
  return r === R.ADMIN || r === "superadmin" || r === "super_admin";
}

export function hasRole(role, allowed) {
  const normalized = normalizeRole(role);
  if (!normalized || !Array.isArray(allowed) || !allowed.length) return false;
  const allowedLower = allowed.map((r) => String(r).toLowerCase());
  return (
    allowedLower.includes(normalized) ||
    (allowedLower.includes(R.ADMIN) && isAdminLike(normalized))
  );
}

export function isPayrollDashboardRole(role) {
  return hasRole(role, PAYROLL_STAFF);
}

export function isTeamLeadRole(role) {
  return hasRole(role, TEAM_LEADS);
}

export function isSelfServiceRole(role) {
  return hasRole(role, SELF_SERVICE);
}

/** Admin and HR may create, edit, or delete organisation holidays. */
export function canManageHolidays(role) {
  return hasRole(role, STAFF);
}

export function formatRoleLabel(role) {
  const r = normalizeRole(role);
  const labels = {
    [R.ADMIN]: "Super Admin",
    [R.HR]: "HR",
    [R.MANAGER]: "Manager",
    [R.EMPLOYEE]: "Employee",
    [R.FINANCE]: "Finance",
  };
  return labels[r] || (r ? r.charAt(0).toUpperCase() + r.slice(1) : "User");
}
